module.exports = __webpack_public_path__ + "img/Frame 794five.75b622ef.png";